import Vue from 'vue';
import Router from 'vue-router';
import Menu from '@/components/AppMenu/Menu/Menu';
import Cliente from '@/components/AppLogin/Cliente/Cliente';
import Test from '@/components/AppLogin/Test/Test';
import Empleado from '@/components/AppLogin/Empleado/Empleado';
const Imprimir        = () => import('@/components/Imprimir/Imprimir.vue');
const Examen   = () => import('@/components/AppMenu/Examen/Examen.vue');

Vue.use(Router)

export default new Router({
	mode:'history',
  	routes: [
	  	{ path: '/', 						name: 'Cliente',  component: Cliente},
	  	{ path: '/cliente/:clave_cliente', 	name: 'Cliente2', component: Cliente},
	  	{ path: '/examen',					name: 'Test', 	  component: Test},
	  	{ path: '/examen/:clave_test',		name: 'Test2', 	  component: Test},
	  	{ path: '/empleado',name: 'Empleado', component: Empleado},
	  	{ path: '/empleado/:clave_empleado',name: 'Empleado2', component: Empleado},
	    { path: '/menu', name: 'Menu', component: Menu, children:[
	    	{ path: 'examen', name: 'Examen', component: Examen }
	    ]},
		{ path: '/imprimir', name: 'Imprimir', component: Imprimir },
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js